import { render, staticRenderFns } from "./ajouterVenteElecComposant.vue?vue&type=template&id=fb25f1a2"
import script from "./ajouterVenteElecComposant.vue?vue&type=script&lang=js"
export * from "./ajouterVenteElecComposant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports